import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaPlay } from "react-icons/fa";
import { HiX } from "react-icons/hi";
import heroImage from "../assets/images/hero-image.png";
import Logo from "../assets/images/logo.png";
import "./home-mobile.css";
import AboutSigiriya from "./about_sigiriya";
import FAQ from "./faq";
import Reviews from "./reviews";
import Partner from "./partner";
import LocationsSection from "./location";
import AboutUs from "./aboutus";
import Process from "./process";
import Footer from "./footer";

function HomeMobile() {
  const navigate = useNavigate();
  const [isTrailerOpen, setIsTrailerOpen] = useState(false);

  return (
    <div>
      {/* Main Content */}
      <div className="bg-[#fdf4e4] min-h-screen flex flex-col items-center text-center px-4 py-6 text-[#3f3a32]">
        {/* Heading */}
        <div className="mb-2">
          <img
            src={Logo}
            alt="Sigiriya VR Logo"
            className="max-w-[380px] w-full h-auto"
          />
        </div>

        {/* Trailer Button */}
        <button
          onClick={() => setIsTrailerOpen(true)}
          className="flex items-center justify-center gap-2 text-sm font-medium mb-6"
        >
          <FaPlay className="text-md" />
          <span>Watch a trailer</span>
        </button>

        {/* Call to Action Buttons */}
        <div className="flex gap-4 mb-4">
          <button
            onClick={() => navigate('/bookings/ekho')}
            className="bg-[#7c623f] text-white font-semibold py-2 px-5 rounded-full text-sm shadow"
          >
            Book Now
          </button>
          <button
            onClick={() => navigate("/view360")}
            className="bg-[#3f3a32] text-white font-semibold py-2 px-5 rounded-full text-sm shadow"
          >
            View 360
          </button>
        </div>

        {/* Hero Image with Scroll text */}
        <div className="relative w-full max-w-xs mb-4">
          <img
            src={heroImage}
            alt="Sigiriya Hero Mobile"
            className="w-full h-auto object-contain rounded-xl"
          />
          <div className="absolute bottom-8 inset-x-0 flex justify-center">
            <p className="text-sm font-ltremark animate-bounce text-white">
              Scroll ↓
            </p>
          </div>
        </div>
      </div>

      {/* Trailer Modal */}
      {isTrailerOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center px-4">
          <div className="relative w-full max-w-3xl bg-white rounded-xl overflow-hidden shadow-lg">
            {/* Close Button */}
            <button
              onClick={() => setIsTrailerOpen(false)}
              className="absolute top-2 right-3 text-2xl text-[#3f3a32] hover:text-[#7c623f] z-10"
            >
              <HiX />
            </button>

            {/* YouTube iframe */}
            <div className="w-full h-[50vw] md:h-[400px]">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/-N7CCHeRteQ?si=4h2P_OjDJGWCcWPB"
                title="Sigiriya VR Trailer"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}

      {/* Remaining Sections */}
      <div className="about-section">
        <AboutSigiriya />
      </div>

      <div className="locations">
        <LocationsSection />
      </div>

      <div className="faq-section">
        <FAQ />
      </div>

      <div className="reviews pt-12 p-3">
        <Reviews />
      </div>

      <div className="partner py-8">
        <Partner />
      </div>

      <div className="aboutus">
        <AboutUs />
      </div>

      <div className="process">
        <Process />
      </div>

      <div className="footer">
        <Footer />
      </div>
    </div>
  );
}

export default HomeMobile;
